/** Editing state is milliseconds; normalized crop is relative to displayed video. */
export interface ReferenceCrop { x: number; y: number; width: number; height: number }
export const FULL_REFERENCE_CROP: ReferenceCrop = { x: 0, y: 0, width: 1, height: 1 };
export const MIN_REFERENCE_MS = 4000;
export const clamp = (n: number, min: number, max: number) => Math.min(Math.max(n, min), max);
export function resizeReferenceCrop(crop: ReferenceCrop, handle: string, dx: number, dy: number, minX = .04, minY = .04): ReferenceCrop {
  if (handle === 'move') return { ...crop, x: clamp(crop.x + dx, 0, 1 - crop.width), y: clamp(crop.y + dy, 0, 1 - crop.height) };
  let left = crop.x, top = crop.y, right = crop.x + crop.width, bottom = crop.y + crop.height;
  if (handle.includes('w')) left = clamp(left + dx, 0, right - minX);
  if (handle.includes('e')) right = clamp(right + dx, left + minX, 1);
  if (handle.includes('n')) top = clamp(top + dy, 0, bottom - minY);
  if (handle.includes('s')) bottom = clamp(bottom + dy, top + minY, 1);
  return { x: left, y: top, width: right - left, height: bottom - top };
}
export function trimReferenceRange(start: number, end: number, target: 'start' | 'end' | 'move', delta: number, duration: number, maxDuration: number): [number, number] {
  if (duration < MIN_REFERENCE_MS) return [0, duration];
  if (target === 'move') { const next = clamp(start + delta, 0, duration - (end - start)); return [next, next + end - start]; }
  if (target === 'start') return [clamp(start + delta, Math.max(0, end - maxDuration), end - MIN_REFERENCE_MS), end];
  return [start, clamp(end + delta, start + MIN_REFERENCE_MS, Math.min(duration, start + maxDuration))];
}
export function referenceEditPayload(sourceId: string, startMs: number, endMs: number, crop: ReferenceCrop) {
  return { source_asset_id: sourceId, start: startMs / 1000, end: endMs / 1000, crop };
}
export function referenceTime(ms: number) {
  const seconds = Math.round(Math.max(0, ms) / 100) / 10;
  return `${Math.floor(seconds / 60).toString().padStart(2, '0')}:${(seconds % 60).toFixed(1).padStart(4, '0')}`;
}
